"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const KeuzeTarief_1 = tslib_1.__importDefault(require("../enums/KeuzeTarief"));
class GetDefaultProductionInput extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '8716879000004',
        description: `The grid operator ean.
    Is obligated if you also specify the net area, captar and profile.
    This has no influence on the tariffs, only on which disclaimer the user gets.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultProductionInput.prototype, "gridOperatorEAN", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '8742010202112',
        description: `States what kind of installation you have.
    For example if you have 3x25 ampere or only 1x80.
    This heavily influences the tariffs you receive.
    You find the result under "Netbeheerder kosten".
    Is obligated if you also specify the net area, grid operator and profile`,
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultProductionInput.prototype, "captarEAN", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '871687940030061178',
        description: `The EAN number of the meter installation.
      If specified and it is a customer of the given brand.
      It will fetch the grid operator ean, net area, captar and profile.
      If it is not a customer, you will get an error.
    `,
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultProductionInput.prototype, "connectEAN", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '14328',
        description: 'Influences the supply rates. Different campaigns have different rates.',
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultProductionInput.prototype, "campaignId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears)),
    (0, base_models_1.Docs)({
        example: base_models_1.DurationInYears.FLEX,
        description: 'The duration of the contract. Influences the proposition. Defaults to 99 also know as flex',
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultProductionInput.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(KeuzeTarief_1.default)),
    (0, base_models_1.Docs)({
        example: KeuzeTarief_1.default.BUDGET,
        description: 'Tied in to with the campaign. Describes .... what ???',
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultProductionInput.prototype, "keuzeTarief", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'G_H_B',
        description: 'is ..... ',
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultProductionInput.prototype, "commodityProduct", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/\d{4}-\d{2}-\d{2}/),
    (0, base_models_1.Docs)({
        example: '2022-12-23',
        description: 'When the contract will start, the tariffs will be fetched that are valid for this date. Defaults to today.',
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultProductionInput.prototype, "startDate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/\d{4}-\d{2}-\d{2}/),
    (0, base_models_1.Docs)({
        example: '2022-12-01',
        description: `Used to check if the given campaign is valid for this period.
    Is usually the first of the next month.
    For "Zeker" campaigns, the tariff date must match with the start of the proposition valid date.
    For all other types of contract the tariff date should be between the start and end of when a proposition is valid.
    Defaults to the first day of the next month.`,
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultProductionInput.prototype, "tariffDate", void 0);
exports.default = GetDefaultProductionInput;
